<!-- side_menu.html -->
<div class='container' style="min-height: 100vh;width:100%;display: flex;flex-direction: column;">
  <img src="@/assets/imgs/logo.jpg" style="width: 5rem;margin-bottom: 1rem;">

  <ul style="list-style-type: none;">
    <li
      v-for="menuvoice in menuvoices"
      :key="menuvoice.id"
      class="menuvoice"
      @click="selectItem(menuvoice.method)"
    >
      <p style="cursor: pointer; text-align: left;">
        <i :class="menuvoice.icon" style="margin-right: 10px;"></i>
        <span class='label'>{{ menuvoice.menuvoice }}</span>
      </p>
    </li>
  </ul>
</div>
